module.exports = __webpack_public_path__ + "img/object-storage.f009e7b.webp";